import * as Sentry from '@sentry/nextjs';
import { registerService } from '@/services/api';
import {
    IAllRegistrationData,
    IRegistrationAddress,
    IRegistrationYotiAddress,
    IWalletPersonalData,
} from 'types/types';

export const getDefaultValues = (
    registrationData: Partial<IAllRegistrationData> | undefined,
    nonMemberPersonalData?: Partial<IWalletPersonalData> | undefined,
) => {
    if (!registrationData && !nonMemberPersonalData) {
        return {
            address1: '',
            zip: '',
            city: '',
            stateCode: '',
            countryCode: '',
        };
    }

    const getDefaultValueForField = (
        walletField: keyof IWalletPersonalData,
        regField: keyof IRegistrationAddress,
        yotiField: keyof IRegistrationYotiAddress,
        fallbackVal = '',
    ) => {
        if (registrationData && registrationData[regField]) {
            return registrationData[regField];
        } else if (registrationData && registrationData[yotiField]) {
            return registrationData[yotiField];
        } else if (nonMemberPersonalData && nonMemberPersonalData[walletField]) {
            return nonMemberPersonalData[walletField];
        } else {
            return fallbackVal;
        }
    };

    return {
        address1: getDefaultValueForField('address1', 'address1', 'yotiAddress1'),
        zip: getDefaultValueForField('zip', 'zip', 'yotiZip'),
        city: getDefaultValueForField('city', 'city', 'yotiCity'),
        stateCode: getDefaultValueForField('stateCode', 'stateCode', 'yotiStateCode'),
        countryCode: getDefaultValueForField('countryCode', 'countryCode', 'yotiCountryCode'),
    };
};

export const submitAddressData = async (
    registrationId: string | null,
    values: Partial<IRegistrationAddress> & { hhidUid?: number },
    onRegistrationComplete: () => Promise<void>,
    resetForm: () => void,
    handleError: (err: unknown) => void,
) => {
    try {
        if (!registrationId) {
            Sentry.captureException(
                new Error('Attempted to submit form but no registration id existed'),
            );
            resetForm();
            return;
        }
        await registerService.finishRegistration(registrationId, values);
        await onRegistrationComplete();
        resetForm();
    } catch (err) {
        handleError(err);
    }
};
